var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4467 5.62153C22.1071 4.26953 21.2711 3.07213 20.2137 2.16373C19.1778 1.27358 17.895 0.633913 16.5338 0.52146C15.0877 0.402158 13.6015 0.903765 12.5238 1.87557C11.8831 2.45342 11.3923 3.19272 11.0938 4.00134C10.6127 3.38278 9.99936 2.86676 9.30044 2.51194C8.00683 1.85504 6.44077 1.75797 5.07625 2.25094C3.79114 2.71436 2.71997 3.6669 1.95172 4.79657C1.16785 5.94936 0.672995 7.3235 0.698081 8.71727C0.729909 10.4633 1.31192 12.3015 2.40072 13.6664C3.5507 15.1081 5.24014 16.1713 6.93106 16.9064C9.77435 18.1432 13.5042 19.6691 13.5042 19.6691C13.5042 19.6691 16.1432 17.0892 18.5653 15.1539C20.0057 14.0027 21.3598 12.5357 22.0937 10.8443C22.7886 9.24158 22.8714 7.31509 22.4467 5.62153Z",
    fill: "#E4DFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup5);
export default __webpack_public_path__ + "static/media/Group-5.2b7d30a94f201c9331d5051b97fcb2ee.svg";
export { ForwardRef as ReactComponent };